import { IN_PROD_LABEL } from '@/lib/versioned-labels';

/**
 * The mark « en prod » of a version (vitrine.md §4.5, issue #192): the version was SENT to the
 * vitrine, and it stays there - the mark is never withdrawn, because sessions of the prod cite
 * it, and several versions of one entity carry it at once, each held by a different referent.
 *
 * Green like « latest prod », and an outline rather than a pill: a pill says where a pointer
 * SITS now, and this says something that happened and cannot be undone. A dot and a word, so
 * the meaning never rests on the colour alone.
 *
 * Only on the atelier: the vitrine has one state, and the callers do not draw it there.
 */
export function InProdMark({ entity }: { entity: string }) {
  return (
    <span
      data-testid={`${entity}-marque-en-prod`}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-sm border border-vert-deep bg-white px-1.5 font-bold text-caption text-vert-deep leading-4"
    >
      <span aria-hidden="true" className="size-1.5 rounded-full bg-vert-deep" />
      {IN_PROD_LABEL}
    </span>
  );
}
